(function() {
  'use strict';

  angular
    .module('admin.users.details.ips', [])
    .controller('IPsAdminCtrl', IPsAdminCtrl);

  /** @ngInject */
  function IPsAdminCtrl($stateParams, $state, UsersService) {
    var vm = this;

    vm.encrypt = function(value){
      var result="";
      for(var i=0;i<value.length;i++){
        if(i<value.length-1){
          result+=value.charCodeAt(i)+10;
          result+="-";
        }
        else{
          result+=value.charCodeAt(i)+10;
        }
      }
      return result;
    }

    vm.decrypt = function(value){
      var result= "";
      var array = value.split("-");
      for(var i = 0;i < array.length; i++){
        result += String.fromCharCode(array[i]-10);
      }
      return result;
    } 

    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.ip =  vm.decrypt($stateParams.ip);
    
    load();

    function load(){
      UsersService.listIPs(vm.ip).then(success);

      function success(result){
        for (var i = 0; i < result.results.length; i++) {
          if (result.results[i].suspended_until) {
            result.results[i].suspended_until = new Date(parseInt(result.results[i].suspended_until.toString().substring(0, result.results[i].suspended_until.toString().length - 3)));
          }
        }
        vm.items = result.results;
      }
    }

    vm.reload = function(ip){
      var ip = vm.encrypt(ip);
      $state.go('admin.users.details.ips', { id: vm.userId, ip: ip })
    }
  }

})();
